import { alpha } from "@mui/material/styles";
import { FS } from "@plannel/utils/font-util";

/*
 * DW 대시보드 recharts 공용 토큰.
 * 모두 theme 기반 — 라이트 모드 결과는 기존 하드코딩 값과 동일하고, 다크 모드에서도 깨지지 않는다.
 *   gridLine  : alpha(text.primary, 0.06)      → 라이트에서 rgba(0,0,0,0.06)
 *
 * 툴팁 생김새는 여기 없다 — components/rechart/AgStyleTooltip 이 앱 전체(ag-charts 포함)를 통일한다.
 */

// CartesianGrid 옅은 선.
export const gridLine = (theme) => alpha(theme.palette.text.primary, 0.06);

// 축 tick 공용 스타일(축 라벨 10px).
export const axisTick = (theme) => ({ fontSize: FS.CAPTION, fill: theme.palette.text.secondary });

/*
 * recharts Tooltip 공용 props — **배치만** 담당한다.
 *
 * 생김새(배경·테두리·그림자·글꼴)는 components/rechart/AgStyleTooltip 이 소유한다.
 * 여기서 contentStyle 을 주면 그 위에 얹혀 ag-charts 통일이 깨지므로 넣지 말 것.
 * (예전엔 여기 자체 contentStyle 이 있어서 이 대시보드만 툴팁이 달랐다)
 */
export const tooltipProps = () => ({
  wrapperStyle: { zIndex: 1000, outline: "none", pointerEvents: "none" },
  /*
   * ★ `allowEscapeViewBox` 를 켜면 안 된다 — 이 옵션은 recharts 가 툴팁을 차트 안에 붙잡아 두는
   *   **자동 위치 조정을 끄는** 스위치다. 켜면 툴팁이 카드 밖으로 나가는데, 카드 그리드에
   *   `overflow: auto` 가 걸려 있어 결국 **잘린다**(오른쪽 끝 카드에서 특히 심하다).
   *   끄면(기본값) recharts 가 커서 반대편으로 뒤집어 항상 차트 안에 들어온다.
   *   좁은 카드에선 툴팁이 차트를 좀 가리지만, 글자가 잘리는 것보다는 낫다.
   */
  allowEscapeViewBox: { x: false, y: false },
});
